import { useSetRecoilState } from 'recoil'
import styled from 'styled-components'

import Close from '~/shared/assets/icons/Close'
import { isNestedModalOpenState } from '~/shared/states'
import theme from '~/shared/styles/theme'

function TermsOfPolicyModal() {
  const setIsNestedModalOpen = useSetRecoilState(isNestedModalOpenState)

  return (
    <Wrapper onClick={(e) => e.stopPropagation()}>
      <CloseIcon
        onClick={() => setIsNestedModalOpen({ contents: '', isOpen: false })}
      />
      <Title>일러스타 페스 안내 및 이용약관</Title>
      <Contents>
        [이용약관] <br />
        일러스타 페스는 일러스트, 웹툰, 게임, 애니메이션, 소설 등 서브컬쳐
        전반에 걸친 창작활동을 함께하고, 돕고, 지원하기 위해 만들어진 서브컬쳐
        이벤트 입니다. 이 이용약관은 &apos;시나리움&apos; 에서 운영을 대행하는
        &apos;일러스타 페스&apos;에서 제공하는 서비스를 이용함에 있어 일러스타
        페스와 회원, 비회원 이용자의 권리와 의무, 책임 사항 및 서비스 이용
        절차에 관해 규정함을 목적으로 합니다. <br />
        <br />
        1. 용어의 뜻 <br /> 이 약관에서 사용하는 용어의 정의는 다음과 같으며, 이
        항목에서 정의되지 않은 약관 상의 용어는 관련 법령 및 관습에 따릅니다.
        &apos;일러스타 페스&apos;은 일러스타 페스 회사를 지칭하며, 일러스타 페스
        웹사이트 내에서 각종 플랫폼 서비스를 제공하는 주체입니다.
        &apos;회원&apos;이라 함은 일러스타 페스이 서비스하는 일러스타 페스
        웹사이트에 접속하여 본 약관에 동의함으로써 일러스타 페스 웹사이트에
        회원등록을 하고 일러스타 페스이 제공하는 각종 서비스를 지속해서 이용할
        수 있는 이용자를 의미합니다.
        <br /> &apos;비회원 이용자&apos;라 함은 본 약관에 동의는 하되 일러스타
        페스에 회원등록은 하지 않고 일러스타 페스과 일러스타페스 웹사이트가
        제공하는 서비스를 한정적으로 이용하는 이용자를 의미합니다. <br />
        &apos;행사&apos;는 일러스타 페스과 일러스타 페스에서 회원과 비회원
        이용자들을 위해 온라인, 오프라인의 특정 공간에서 진행하는 행사를
        의미합니다.
        <br />
        <br /> 2. 약관에 대한 명시와 동의, 개정 <br /> 일러스타 페스는 이 약관의
        내용과 상호 및 대표자 성명, 영업소 소재지 주소, 전화번호, 전자우편주소,
        사업자등록번호, 통신판매업 신고번호 등을 이용자가 쉽게 알 수 있도록
        일러스타 페스 웹페이지의 하단 메뉴를 통해 게시합니다. 다만, 약관의
        내용과 개인정보 취급방침은 연결된 링크를 통하여 볼 수 있도록 합니다.
        <br />
        일러스타 페스에서는 이용자가 약관에 동의하기에 앞서, 약관에 정하여져
        있는 내용 중 실물 배송 상품의 청약철회, 배송책임, 환불조건 등과 같은
        중요한 내용을 이용자가 이해할 수 있도록 별도의 연결화면 또는 팝업화면
        등을 제공하여 이용자의 확인을 구합니다. <br /> 일러스타 페스는
        「전자상거래 등에서의 소비자보호에 관한 법률」, 「약관의 규제에 관한
        법률」, 「전자문서 및 전자거래기본법」, 「전자금융거래법」,
        「전자서명법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」,
        「방문판매 등에 관한 법률」, 「소비자기본법」 등 관련 법을 위배하지 않는
        범위에서 이 약관을 개정할 수 있습니다. <br /> 이 약관을 개정할 경우에는
        적용일자 및 개정사유를 명시하여 현행약관과 함께 일러스타 페스의
        초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다. <br />
        다만, 이용자에게 불리하게 약관내용을 변경하는 경우에는 최소한 30일
        이상의 사전 유예기간을 두고 공지합니다. 이 경우 일러스타 페스는 개정 전
        내용과 개정 후 내용을 명확하게 비교하여 이용자가 알기 쉽도록 표시합니다.
        <br /> 약관을 개정할 경우, 그 개정약관은 그 적용일자 이후에 체결되는
        계약에만 적용되고 그 이전에 이미 체결된 계약에 대해서는 개정 전의
        약관조항이 그대로 적용됩니다. <br /> 다만 이미 계약을 체결한 이용자가
        개정약관 조항의 적용을 받기를 원하는 뜻을 제3항에 의한 개정약관의
        공지기간 내에 일러스타 페스에 송신하여 일러스타 페스의 동의를 받은
        경우에는 개정약관 조항이 적용됩니다.
      </Contents>
    </Wrapper>
  )
}

export default TermsOfPolicyModal

const Wrapper = styled.section`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  gap: 36px;
  align-items: center;

  box-sizing: border-box;
  width: 979px;
  height: 924px;
  margin: 0 auto;
  padding: 108px 77px 60px;

  background-color: ${theme.colors.white};
  border-radius: 12px;

  @media ${theme.device.medium} {
    width: 90%;
    height: 80%;
    padding: 56px 20px 30px;
  }
`

const CloseIcon = styled(Close)`
  position: absolute;
  top: 36px;
  right: 36px;

  @media ${theme.device.medium} {
    top: 20px;
    right: 20px;
    width: 24px;
    height: 24px;
  }
`

const Title = styled.h1`
  margin: 10px 0;
  font-family: NanumSquareNeo-Regular, sans-serif;
  font-size: 42px;
  font-weight: 500;

  @media ${theme.device.medium} {
    font-size: 21px;
  }
`

const Contents = styled.div`
  overflow-y: scroll;
  font-family: NanumSquareNeo-Light, sans-serif;
  font-size: 18px;
  line-height: 25px;
`
